import { Flex, Typography } from 'antd';
import { AutoSizer } from 'react-virtualized';
import _ from 'lodash';
import React from 'react';
import dayjs from 'dayjs';
import { Line } from '@nivo/line';

interface IRenderedPieChart {
	rows?: string;
	kind?: string;
	date?: string;
	value?: string;
	title?: string;
}



export default function RenderedLineChart({ rows, title, date, kind, value, }:IRenderedPieChart) {

	const data = React.useMemo(() => {
		try {
			if(!rows) return [];
			if(!kind || !date || !value) return [];

			const _rows = JSON.parse(rows ?? '') as ({[key: string]: string | number })[];

			const _data = _rows.map((row) => {
				return {
					type: row[kind],
					value: row[value],
					date: row[date],
				};
			});

			const grouped = _.groupBy(_data, 'type');
			const result = Object.entries(grouped).map(([ key, values, ]) => {
				const id = key;
				const data = values.map((value) => {
					return {
						x: dayjs(value.date as string).format('YYYY-MM-DD'),
						y: value.value,
					};
				});
				return {
					id,
					data,
				};
			});
			return result;
		}catch(error){
			return [];
		}
	}, [ date, kind, value, ]);

    
	return (
		<Flex vertical style={{
			width: '100%',
			height: '100%',
			flex: 1,
			padding: 12,
			overflow: 'hidden',
		}}
		>
			<Typography.Title level={4}>{title}</Typography.Title>
			{!!data?.length && <AutoSizer>
				{({ height, width, }) => (
					<Line
						width={width}
						height={height}
						animate={false}
						margin={{
							top: 27,
							right: 50,
							bottom: 50,
							left: 60,
						}}
						data={data}
						xScale={{
							type: 'time',
							format: '%Y-%m-%d',
							useUTC: false,
							precision: 'day', 

						}}
						lineWidth={4}
						axisBottom={{
							tickValues: data?.at(0)?.data?.length,
							format: '%d/%m/%Y',
						}}
						enableArea
						enableCrosshair={true}
						curve='monotoneX'
						enableSlices='x'
						enableGridX={false}
						legends={[
							{
								anchor: 'top-right',
								direction: 'row',
								justify: false,
								translateX: 0,
								translateY: -25,
								itemsSpacing: 8,
								itemDirection: 'left-to-right',
								itemWidth: 80,
								itemHeight: 10,
								itemOpacity: 0.75,
								symbolSize: 12,
								symbolShape: 'circle',
								symbolBorderColor: 'rgba(0, 0, 0, .5)',
								effects: [
									{
										on: 'hover',
										style: {
											itemBackground: 'rgba(0, 0, 0, .03)',
											itemOpacity: 1,
										},
									},
								],
							},
						]}
					/>
				)}
			</AutoSizer>}
			
		</Flex>
	);
}
